export { default } from './PrivacyPolicyScreen';
export * from './PrivacyPolicyScreen';
